import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthShell from '../comps/authShell'
import { Input, InputErrorMassage } from '../comps/comps'
import { getSignupDraft, setSignupDraft } from '../utils/signupDraft'
import * as actions from '../store/authAction'

const AuthVerify = () => {
  const navigate = useNavigate()
  const [code, setCode] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [email, setEmail] = useState('')
  const [preview, setPreview] = useState('')

  useEffect(() => {
    const draft = getSignupDraft()
    if (!draft.email) {
      navigate('/auth', { replace: true })
      return
    }
    if (draft.emailVerified) {
      navigate('/auth/setup/password', { replace: true })
      return
    }
    setEmail(draft.email)
    const shown = String(draft.codePreview || '').replace(/\D/g, '').slice(0, 6)
    setPreview(shown)
    if (shown.length === 6) setCode(shown)
  }, [navigate])

  const next = async () => {
    setError('')
    if (code.replace(/\s/g, '').length !== 6) {
      setError('Enter the 6-digit code')
      return
    }
    setBusy(true)
    try {
      await actions.check_code(email, code)
      setSignupDraft({ email, emailVerified: true })
      navigate('/auth/setup/password')
    } catch (err) {
      setError(err && err.message ? err.message : 'Wrong code')
    }
    setBusy(false)
  }

  const resend = async () => {
    setError('')
    setBusy(true)
    try {
      const sent = await actions.send_code(email)
      if (sent && sent.preview) {
        const shown = String(sent.preview).replace(/\D/g, '').slice(0, 6)
        setPreview(shown)
        setCode(shown)
        setSignupDraft({ codePreview: shown })
      }
    } catch (err) {
      setError(err && err.message ? err.message : 'Could not send the code')
    }
    setBusy(false)
  }

  return (
    <AuthShell title="Enter your code">
      <p className="authStepLabel">{preview ? `Your code for ${email}` : `We sent a code to ${email}`}</p>
      {preview ? <p className="authCodePreview">{preview}</p> : null}
      <Input placeholder="6-digit code" value={code} onChange={e => setCode(e.target.value.replace(/[^\d]/g, '').slice(0, 6))} />
      {error ? <InputErrorMassage val={'hi'} num={[10, 10]} text={error} /> : null}
      <button type="button" className="googlebuttons" onClick={next} disabled={busy}>{busy ? 'Checking…' : 'Next'}</button>
      <p className="googlebuttonss" onClick={() => { if (!busy) resend() }}>Send a new code</p>
      <p className="googlebuttonss" onClick={() => navigate('/auth')}>Back</p>
    </AuthShell>
  )
}

export default AuthVerify
